export const GET_BENIFICIARYS = "GET_BENIFICIARYS";
export const FILTER_BENIFICIARYS = "FILTER_BENIFICIARYS";
export const ADD_BENIFICIARY = "ADD_BENIFICIARY";
export const EDIT_BENIFICIARY = "EDIT_BENIFICIARY";
export const GET_BENIFICIARY = "GET_BENIFICIARY";
export const RESET_BENIFICIARY = "RESET_BENIFICIARY";
export const BENIFICIARYS_ERROR = "BENIFICIARYS_ERROR";
